import { ChatSnapshot } from "../types";

export function createDefaultSnapshot(): ChatSnapshot {
  return {
    roster: {},
    conversations: {
      inbox: [],
      unread: [],
      communities: [],
    },
  };
}

